"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "belluno": {
    "7246efdb": [{
      "hkey": "b073e860",
      "slug": "bolzano-bellunese-pascoli",
      "name": "Bolzano Bellunese-Pascoli",
      "primary": true,
      "skipSearch": false
    }],
    "bolzano-bellunese": [{
      "hkey": "b073e860",
      "slug": "bolzano-bellunese-pascoli",
      "name": "Bolzano Bellunese-Pascoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bc6dc568": [{
      "hkey": "27c3108c",
      "slug": "castoi-cet",
      "name": "Castoi-Cet",
      "primary": true,
      "skipSearch": false
    }],
    "castoi": [{
      "hkey": "27c3108c",
      "slug": "castoi-cet",
      "name": "Castoi-Cet",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7cdd721a": [{
      "hkey": "3a77fca4",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "3a77fca4",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "belluno"
    }],
    "bdc9a486": [{
      "hkey": "27c3108c",
      "slug": "castoi-cet",
      "name": "Castoi-Cet",
      "primary": true,
      "skipSearch": false
    }],
    "cet": [{
      "hkey": "27c3108c",
      "slug": "castoi-cet",
      "name": "Castoi-Cet",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "belluno"
    }],
    "2ec93e8c": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "skipSearch": false
    }],
    "chiesurazza": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3923ef30": [{
      "hkey": "74859278",
      "slug": "feltre",
      "name": "Feltre",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "5f367291",
      "slug": "mussoi",
      "name": "Mussoi",
      "primary": false,
      "skipSearch": false
    }],
    "col-di-piana": [{
      "hkey": "74859278",
      "slug": "feltre",
      "name": "Feltre",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "belluno"
    }],
    "4cabb435": [{
      "hkey": "ef768d16",
      "slug": "salce-giamosa",
      "name": "Salce-Giamosa",
      "primary": true,
      "skipSearch": false
    }],
    "col-di-salce": [{
      "hkey": "ef768d16",
      "slug": "salce-giamosa",
      "name": "Salce-Giamosa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "belluno"
    }],
    "a79e6dd3": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "skipSearch": false
    }],
    "cusighe": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "58b1b5c5": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "skipSearch": false
    }],
    "faverga": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4c744ed8": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "skipSearch": false
    }],
    "fiammoi": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e5f49370": [{
      "hkey": "ef768d16",
      "slug": "salce-giamosa",
      "name": "Salce-Giamosa",
      "primary": true,
      "skipSearch": false
    }],
    "giamosa": [{
      "hkey": "ef768d16",
      "slug": "salce-giamosa",
      "name": "Salce-Giamosa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "belluno"
    }],
    "ba2e21cd": [{
      "hkey": "966d4a35",
      "slug": "tisoi-giazzoi",
      "name": "Tisoi-Giazzoi",
      "primary": true,
      "skipSearch": false
    }],
    "giazzoi": [{
      "hkey": "966d4a35",
      "slug": "tisoi-giazzoi",
      "name": "Tisoi-Giazzoi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "belluno"
    }],
    "33b9c097": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "skipSearch": false
    }],
    "madeago": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "75403059": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "skipSearch": false
    }],
    "mier": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c68b3f8c": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "skipSearch": false
    }],
    "pedeserva": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1cf53e2": [{
      "hkey": "547bab3e",
      "slug": "baldenich-cavarzano-nogare",
      "name": "Baldenich-Cavarzano-Nogarè",
      "primary": true,
      "skipSearch": false
    }],
    "per-ovest-dx-piave": [{
      "hkey": "547bab3e",
      "slug": "baldenich-cavarzano-nogare",
      "name": "Baldenich-Cavarzano-Nogarè",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "belluno"
    }],
    "1e00f32f": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "skipSearch": false
    }],
    "per-ovest-sx-piave": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1a92e2f": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "skipSearch": false
    }],
    "periferia-est": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f02f8f90": [{
      "hkey": "72d117a3",
      "slug": "visome-rivamaor",
      "name": "Visome-Rivamaor",
      "primary": true,
      "skipSearch": false
    }],
    "rivamaor": [{
      "hkey": "72d117a3",
      "slug": "visome-rivamaor",
      "name": "Visome-Rivamaor",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "belluno"
    }],
    "f0534b9c": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "skipSearch": false
    }],
    "sala": [{
      "hkey": "9c45d19c",
      "slug": "belluno",
      "name": "Belluno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5d4401f0": [{
      "hkey": "ef768d16",
      "slug": "salce-giamosa",
      "name": "Salce-Giamosa",
      "primary": true,
      "skipSearch": false
    }],
    "salce": [{
      "hkey": "ef768d16",
      "slug": "salce-giamosa",
      "name": "Salce-Giamosa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0b024985": [{
      "hkey": "783bc4b5",
      "slug": "caleipo-sossai",
      "name": "Caleipo-Sossai",
      "primary": true,
      "skipSearch": false
    }],
    "sossai": [{
      "hkey": "783bc4b5",
      "slug": "caleipo-sossai",
      "name": "Caleipo-Sossai",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "belluno"
    }],
    "70113d4b": [{
      "hkey": "966d4a35",
      "slug": "tisoi-giazzoi",
      "name": "Tisoi-Giazzoi",
      "primary": true,
      "skipSearch": false
    }],
    "tisoi": [{
      "hkey": "966d4a35",
      "slug": "tisoi-giazzoi",
      "name": "Tisoi-Giazzoi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "81e82a73": [{
      "hkey": "72d117a3",
      "slug": "visome-rivamaor",
      "name": "Visome-Rivamaor",
      "primary": true,
      "skipSearch": false
    }],
    "visome": [{
      "hkey": "72d117a3",
      "slug": "visome-rivamaor",
      "name": "Visome-Rivamaor",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;